import { USER_CONSTANTS } from 'src/constants/user';
import { clearDailyBoostVariantCache } from 'src/utils/dailyBoostVariant';
import { resetDailyBoost } from 'src/modules/daily-boost/actions/daily-boost';
import {
  SET_USER, LOGOUT, READ_NOTIFICATION,
} from '../actionTypes';
import { logoutApi } from '../modules/common/api';
import { resetAnalytics } from '../services/analytics';

export const setUser = (userParams) => ({
  type: SET_USER,
  payload: userParams,
});

export const logoutAction = () => {
  localStorage.removeItem('timeToFreeVote');
  // Clear any onboarding draft + resume marker + carried distinct_id so a
  // different user on a shared browser is never redirected into the previous
  // user's pet draft or aliased onto their analytics identity.
  localStorage.removeItem('onboarding_draft');
  localStorage.removeItem('onboarding_resume');
  localStorage.removeItem('onboarding_alias_id');
  return { type: LOGOUT };
};

export const readUserNotification = () => ({ type: READ_NOTIFICATION });

export const logout = (apiToken) => {
  localStorage.removeItem('timeToFreeVote');
  localStorage.removeItem('pupswipeWinItem');
  localStorage.removeItem('onboarding_draft');
  localStorage.removeItem('onboarding_resume');
  localStorage.removeItem('onboarding_alias_id');
  // Daily Boost: next user on a shared browser must re-bucket.
  clearDailyBoostVariantCache();
  resetAnalytics();

  return (dispatch) => {
    dispatch(resetDailyBoost());
    dispatch(logoutAction());
    logoutApi(apiToken).then((data) => {
      dispatch(logoutAction());
    });
  };
};

export const setWallet = (payload) => ({
  type: USER_CONSTANTS.SET_WALLET,
  payload,
});

export const updateUser = (payload) => ({
  type: USER_CONSTANTS.UPDATE,
  payload,
});
